export class Breakpoint {
  /**
   * @param {string} key - The key identifier for the breakpoint.
   * @param {?number} [minSize=null] - The minimum size for the breakpoint in pixels.
   * @param {?number} [maxSize=null] - The maximum size for the breakpoint in pixels.
   * @throws Will throw an error if both minSize and maxSize are null.
   */
  constructor(key, minSize = null, maxSize = null) {
    if (minSize === null && maxSize === null) {
      throw new Error('At least one of minSize or maxSize must have a value.')
    }
    this.key = key
    this.minSize = minSize
    this.maxSize = maxSize
  }

  /**
   * @returns {number} The pixel size of the breakpoint.
   */
  size() {
    if (this.maxSize !== null) {
      return this.maxSize
    }
    if (this.minSize !== null) {
      return this.minSize
    }
    return 0
  }

  /**
   * Convert the breakpoint to a media condition string.
   * @returns {string} The media condition string.
   */
  toMediaCondition() {
    if (this.minSize !== null && this.maxSize !== null) {
      return `(min-width: ${this.minSize}px) and (max-width: ${this.maxSize}px)`
    }
    if (this.minSize !== null) {
      return `(min-width: ${this.minSize}px)`
    }
    if (this.maxSize !== null) {
      return `(max-width: ${this.maxSize}px)`
    }
    // This return statement should never be reached due to the constructor assertion.
    return ''
  }
}
